<template lang="pug">
  .TopImages
    StarrySky
    div
      img(:src="img")
      h1 重新定义未来生活的新形态
    
</template>

<script>
  import StarrySky from "@/components/StarrySky";
  import img from '@/assets/images/关于我们页面公司LOGO.png'
  import background from '@/assets/images/关于我们banner.png'
  export default {
    name: "TopImages",
    components: {StarrySky},
    data() {
      return {
        img,
        background,
      }
    },
  };
</script>

<style scoped lang="stylus">
  @import "../index.styl"
  .TopImages {
    position relative
    background url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E5%A4%A7%E5%9B%BE/%E5%85%B3%E4%BA%8E%E6%88%91%E4%BB%ACbanner.png") no-repeat center
    background-color black
    height (870 / 1920)*100vw
    width 100%
    background-size 100%
    > div {
      position absolute
      top 330px
      left 300px
      > img {
        margin-bottom 10px
      }
    }
    h1 {
      color white
      font-size 36px
      font-weight 200
      FontSetting("思源黑体")
      &::before, &::after {
        content none
      }
    }
    @media (max-width ipadProScreenWidth) {
      > div {
        top calc(50% - 70px)
        left calc(50% - 242.5px)
      }
    }
    @media (max-width screenWidth) {
      height 600px
      background-position -775px 190px
      background-size auto 100%
      > div {
        height 170px
        width 308px
        left calc(50% - 154px)
        top calc(50% - 120px)
        > img {
          width 300px
        }
        h1 {
          font-size 24px
        }
      }
    }
  }
</style>
